import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {ConsumiModalComponent} from './consumi-modal';

export const ConsumiModalModule: string = ng
  .module('archiSmall.components.consumiModalModule', [
    'ui.bootstrap',
    uiRouter
  ])
  .component('consumiModalComponent', ConsumiModalComponent)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/consumi-modal/consumi-modal.module.ts